import React, {useMemo} from 'react';
import cn from 'classnames';

import SearchModel from 'coreClasses/search/SearchModel';
import {useLocation, useSearchMgrInstance} from 'coreHooks';
import {useCategory, useParentCategoryTree} from 'coreHooks/categories';

import {useCategoryContext} from 'brand/app/pages/category/context/CategoryContext';
import styles from 'brandComponents/Breadcrumbs/Breadcrumbs.module.scss';

import {IBreadcrumbsProps} from '../IBreadcrumbs';

import Breadcrumb from './Breadcrumb';

const CategoryBreadcrumbs = ({
	product,
	prefixItems = [],
	showProductName = true,
	lastCategoryLabelVariant
}: IBreadcrumbsProps) => {

	const location = useLocation();
	const {cgid, isPrevPageLoaded} = useCategoryContext(true) || {};
	const searchQuery = useMemo(() => location.searchParams.get('q'), [location.searchParams]);
	const homeItem = useMemo(() => ({
		url: '/',
		label: 'Home'
	}), []);
	prefixItems.push(homeItem);

	const searchMgr = useSearchMgrInstance();
	const searchModel: SearchModel = searchMgr.getStoredSearchModel();
	const category = useCategory(product?.getPrimaryCategoryId() || searchModel?.getSelectedRefinements()?.cgid || cgid);
	const parentCategoryTree = useParentCategoryTree(category);

	return (
		<div className={cn(
			'breadcrumbs-container',
			styles['breadcrumbs__container'],
			{
				[styles['breadcrumbs__container--search']]: searchQuery,
				['hidden']: !isPrevPageLoaded && cgid && searchModel.getLowestLoadedPageNumber() > 1
			}
		)}>
			<ul className={cn('breadcrumbs', styles['breadcrumbs__list'])}>
				{!!prefixItems.length && prefixItems.map(item => (
					<li key={item.label} className={styles['breadcrumbs__item']}>
						<Breadcrumb {...item} classNames={styles['breadcrumbs__item-link']} />
					</li>
				))}
				{parentCategoryTree ? (
					parentCategoryTree.map((category, index: Number) => {
						const url = product?.getProductId() || parentCategoryTree.length !== +index + 1
							? category?.getUrl()
							: null;

						return (
							<li key={category?.getId()} className={styles['breadcrumbs__item']}>
								<Breadcrumb
									classNames={styles['breadcrumbs__item-link']}
									url={url}
									category={category}
									labelVariant={
										index === (parentCategoryTree.length - 1) && lastCategoryLabelVariant
											? lastCategoryLabelVariant
											: 'span'
									}
								/>
							</li>
						);
					})
				) : (
					<li className={styles['breadcrumbs__item']} />
				)}
				{showProductName && !!product && !!product?.getName() && (
					<li className={styles['breadcrumbs__item']}>
						<Breadcrumb label={product?.getName()} />
					</li>
				)}
			</ul>
		</div>
	);
};

export default CategoryBreadcrumbs;
